module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-10.797be0a0.svg";